export const data = function () {
  return {
    dialogIndicadores: false,
    showComprovante: false,
    showComprovanteLaudo: false,
    showComprovanteAgendamento: false,
    page: {
      title: 'Relatório de Cancelados',
    },
    headers: [
      {
        habilited: true,
        block: true,
        text: 'Ações',
        value: 'actions',
        sortable: false,
      },
      { habilited: true, block: true, text: 'Status', value: 'status' },
      {
        habilited: true,
        block: false,
        text: 'Cancelado Por',
        value: 'cancelado_por',
      },
      {
        habilited: true,
        block: false,
        text: 'Cancelado Em',
        value: 'cancelado_em',
      },
      {
        habilited: true,
        block: false,
        text: 'Veículo',
        value: 'veiculo',
      },
      {
        habilited: true,
        block: false,
        text: 'Senha',
        value: 'senhas',
      },
      {
        habilited: true,
        block: false,
        text: 'Tipo Operação',
        value: 'tipo_operacao',
      },
      {
        habilited: true,
        block: false,
        text: 'Agendado Em',
        value: 'agendado_em',
      },
      {
        habilited: true,
        block: false,
        text: 'Triado Em',
        value: 'triado_em',
      },
      {
        habilited: true,
        block: false,
        text: 'Cliente',
        value: 'cliente',
      },
      {
        habilited: true,
        block: false,
        text: 'SubProduto',
        value: 'pedidos_agendados.sub_produto',
      },
      {
        habilited: true,
        block: false,
        text: 'Quantidade (KG)',
        value: 'pedidos_agendados.quantidade',
      },
      {
        habilited: true,
        block: false,
        text: 'Embalagem',
        value: 'pedidos_agendados.embalagem',
      },
      {
        habilited: true,
        block: false,
        text: 'Terminal',
        value: 'terminal',
      },
      {
        habilited: true,
        block: false,
        text: 'Terminal Destino',
        value: 'terminal_destino',
      },
      {
        habilited: true,
        block: false,
        text: 'Baixa automática',
        value: 'baixa_automatica',
      },
      {
        habilited: true,
        block: false,
        text: 'Região',
        value: 'regiao',
      },
      {
        habilited: true,
        block: false,
        text: 'Eixos',
        value: 'eixos',
      },
      {
        habilited: false,
        block: false,
        text: 'Motorista',
        value: 'motorista',
      },
      {
        habilited: false,
        block: false,
        text: 'Proprietário',
        value: 'proprietario',
      },
      {
        habilited: false,
        block: false,
        text: 'Transportadora',
        value: 'transportadora',
      },
      {
        habilited: false,
        block: false,
        text: 'Destinatário',
        value: 'destinatario',
      },
      {
        habilited: false,
        block: false,
        text: 'Nº Pedido',
        value: 'pedidos_agendados.num_pedido',
      },
      {
        habilited: false,
        block: false,
        text: 'Nota Fiscal',
        value: 'nota_fiscal',
      },
      {
        habilited: false,
        block: false,
        text: 'Produto',
        value: 'pedidos_agendados.produto',
      },

      {
        habilited: false,
        block: false,
        text: 'Návio',
        value: 'navio',
      },
      {
        habilited: false,
        block: false,
        text: 'Tipo Frete',
        value: 'tipo_frete',
      },
      { habilited: false, block: false, text: 'DI', value: 'di' },

      { habilited: false, block: false, text: 'Píer', value: 'pier' },
      {
        habilited: false,
        block: false,
        text: 'Observação',
        value: 'observacao',
      },
    ],
    breadcrumbs: [
      {
        text: 'Logística',
        disabled: false,
      },
      {
        text: 'Relatório Cancelados',
        disabled: false,
      },
    ],
  }
}
